module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Git#3-c1ca91c5dfa14258c9ce1d08ab6983d79eeb94be4333a559cbb022b339611f37.svg";